import { FlowMeter } from './flow-meter';

/**
 * The `_cls` MongoDB class discriminator for a flow meter installation.
 */
export enum FlowMeterInstallationType {
  TwoLines = 'TwoLines',
  SingleLineAutoPopulated = 'SingleLineAutoPopulated',
  DuelFuelEngineMESingleLine = 'DuelFuelEngineMESingleLine',
  DuelFuelEngineMEAESingleLine = 'DuelFuelEngineMEAESingleLine',
  DualFuelEngineMEAEDifferential = 'DualFuelEngineMEAEDifferential',
  DuelFuelFuelDifferentialAEPortAndStarboard = 'DuelFuelFuelDifferentialAEPortAndStarboard',
  InletAB12DiffCB = 'InletAB12DiffCB',
  InletAB12CBAutoPopulated = 'InletAB12CBAutoPopulated',
  GasInletAB1 = 'GasInletAB1',
  GasInletAB12 = 'GasInletAB12',
}

export interface FlowMeterInstallation {
  _cls: FlowMeterInstallationType | string;
  flow_meters: Record<string, FlowMeter>;
  gas_flow_meters: Record<string, FlowMeter>;
}
